import { render } from "./Tenant_Deposits.vue?vue&type=template&id=38e9f570"
import script from "./Tenant_Deposits.vue?vue&type=script&lang=js"
export * from "./Tenant_Deposits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__